import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Text from "./Text"
import { colourFromProps } from "./theme"

const Container = styled.button`
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: normal;
  color: ${(props) => props.theme.colours.text.primary};
  background-color: #666669;
  font-weight: normal;
  border: none;
  border-left: ${(props) => {
    const col = colourFromProps(props)
    return col ? `2px solid ${col}` : "none"
  }};
  border-radius: ${(props) => props.theme.corners};
  cursor: pointer;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  // Default space between adjacent buttons
  & + button,
  & + input {
    margin-left: 0.5rem;
  }
  opacity: ${(props) => (props.disabled ? "0.5" : "1.0")};
  transition: opacity 0.3s ease-out;
`

const PrefixIcon = styled(Text)`
  padding-right: 1rem;
`

const Button = (props) => (
  <Container {...props}>
    {props.icon && props.children && (
      <PrefixIcon {...props}>
        <FontAwesomeIcon icon={props.icon} />
      </PrefixIcon>
    )}
    {props.icon && !props.children && (
      <Text {...props}>
        <FontAwesomeIcon icon={props.icon} />
      </Text>
    )}
    {props.children}
  </Container>
)

Button.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any,
}

export default Button
